import { createReducer } from "@reduxjs/toolkit";

import {
  deleteMySubscriptionSuccess,
  getSubscriptionDetails,
  getSubscriptionDetailsReset,
} from "../subscriptions/actions";
import {
  addSubscriptionDetailsPosts,
  setSubscriptionDetails,
  setSubscriptionDetailsPosts,
} from "./actions";

const initialState = {
  annualPrice: undefined,
  audioPostsCount: undefined,
  createdAt: undefined,
  description: undefined,
  id: undefined,
  imagePostsCount: undefined,
  isDeleted: undefined,
  isSubscribed: undefined,
  minPrice: undefined,
  monthlyPrice: undefined,
  position: undefined,
  priceType: undefined,
  semiAnnualPrice: undefined,
  textPostsCount: undefined,
  title: undefined,
  uniqueKey: undefined,
  updatedAt: undefined,
  videoPostsCount: undefined,
  isLoading: true,
  error: null,
  totalCount: null, // posts count
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getSubscriptionDetails.type, (state) => {
      state.isLoading = true;
    })
    .addCase(setSubscriptionDetails.type, (_state, action) => ({
      ..._state,
      ...action.payload,
      isLoading: false,
      error: initialState.error,
    }))
    .addCase(deleteMySubscriptionSuccess.type, (state, { payload }) => ({
      ...state,
      isDeleted: state.id === payload?.id ? true : false,
    }))
    .addCase(setSubscriptionDetailsPosts.type, (state, { payload }) => {
      const { id, totalCount, allPosts } = payload;
      if (id === state.id) {
        state.posts = allPosts;
        state.totalCount = totalCount;
      }
    })
    .addCase(addSubscriptionDetailsPosts.type, (state, { payload }) => {
      const { id, totalCount, allPosts } = payload;

      if (id === state.id) {
        state.totalCount = totalCount;
        state.posts = [...state.posts, ...allPosts];
      }
    })
    .addCase(getSubscriptionDetailsReset.type, () => ({ ...initialState }));
});
